import React, { Component } from 'react'
import { remove } from 'lodash'

import './MultipleDateSelector.scss'
import LabeledIcon from 'components/LabeledIcon'

const weekdays = [
  {
    name: 'Lunes',
    slug: 'monday'
  },
  {
    name: 'Martes',
    slug: 'tuesday'
  },
  {
    name: 'Miércoles',
    slug: 'wednesday'
  },
  {
    name: 'Jueves',
    slug: 'thursday'
  },
  {
    name: 'Viernes',
    slug: 'friday'
  },
  {
    name: 'Sábado',
    slug: 'saturday'
  },
  {
    name: 'Domingo',
    slug: 'sunday'
  },
]

class MultipleDateSelector extends Component {
  isWeekdaySelected (weekday) {
    return this.props.input.value.indexOf(weekday.slug) > -1
  }

  onChange (weekday) {
    const { input } = this.props
    const { value, onChange } = input

    let newValue = [].concat(value)

    if (this.isWeekdaySelected(weekday)) {
      const sameAs = value => other => value === other
      remove(newValue, sameAs(weekday.slug))
    } else {
      newValue.push(weekday.slug)
    }

    onChange(newValue)
  }

  render () {
    return (
      <div className='MultipleDateSelector'>
        {weekdays.map(weekday => (
          <LabeledIcon
            key={weekday.slug}
            selected={this.isWeekdaySelected(weekday)}
            onClick={() => this.onChange(weekday)}
            iconType='text'
            iconContent={weekday.name.slice(0, 2)}
            label={weekday.name}
            />
        ))}
      </div>
    )
  }
}

export default MultipleDateSelector



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/MultipleDateSelector/MultipleDateSelector.js